import { IonRange, IonButton, IonIcon, IonText } from '@ionic/react';
import { pause, play, videocam, videocamOff } from 'ionicons/icons';
import _ from 'lodash';
import { RunModel } from 'models/RunModel/RunModel';
import FigureScorePopup from 'pages/ViewRunPage/FigureScorePopup';
import RunStatsBox from 'pages/ViewRunPage/RunStatsBox';
import GForceDisplay from 'pages/ViewRunPage/components/GForceDisplay';
import { useMemo } from 'react';

interface SequencePlayerProps {
  max: number;
  value: number;
  valueToMs?: (value: number) => number;
  timeValue: string;
  onChange?: (value: number) => void;
  onKnobMoveStart?: () => void;
  togglePlaying?: () => void;
  isPlaying: boolean;
  record: RunModel;
  step?: number;
  toggleVideo: () => void;
  videoActive: boolean;
  hasVideo: boolean;
  showRunStatsBox?: boolean;
  showFigurePopup?: boolean;
  showGForceDisplay?: boolean;
}

/* const identity = _.identity; // typescript doesn't like this... */
const identity = (v: any) => v;

const SequencePlayer = (props: SequencePlayerProps) => {
  const {
    max,
    step = 1,
    value,
    onChange,
    togglePlaying,
    isPlaying,
    record,
    onKnobMoveStart,
    timeValue,
    valueToMs = identity,
    toggleVideo,
    videoActive,
    hasVideo,
    showRunStatsBox = true,
    showFigurePopup = false,
    showGForceDisplay = false,
  } = props;

  // Play/Pause-Button und Slider sind jetzt State-Machine-gesteuert
  return (
    <div className="mediaButtonBar">
      {showRunStatsBox && (
        <div
          style={{ display: 'flex', justifyContent: 'end', padding: '16px' }}
        >
          <RunStatsBox ms={valueToMs(value)} record={record} />
        </div>
      )}
      {showFigurePopup && (
        <div
          style={{ display: 'flex', justifyContent: 'end', padding: '16px' }}
        >
          <FigureScorePopup record={record} ms={valueToMs(value)} />
        </div>
      )}
      {showGForceDisplay && (
        <div
          style={{ display: 'flex', justifyContent: 'end', padding: '16px' }}
        >
          <GForceDisplay
            record={record}
            currentTimeMs={valueToMs(value)}
            isVisible={showGForceDisplay}
          />
        </div>
      )}
      <div>
        <IonRange
          id="play-bar"
          style={{
            margin: 0,
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 0,
          }}
          min={0}
          max={max}
          step={step}
          value={value}
          onIonInput={(event) => onChange?.(event.detail.value as number)}
          onIonKnobMoveStart={onKnobMoveStart}
        >
          <IonButton
            id="play-button"
            slot="start"
            onClick={togglePlaying}
            fill="clear"
          >
            <IonIcon color="primary" icon={isPlaying ? pause : play} />
          </IonButton>
          {hasVideo && (
            <IonButton
              id="video-button"
              slot="end"
              onClick={toggleVideo}
              fill="clear"
            >
              <IonIcon
                color="primary"
                icon={videoActive ? videocam : videocamOff}
              />
            </IonButton>
          )}
        </IonRange>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 16px',
        }}
      >
        <IonText 
          style={{ 
            fontSize: 14,
            color: process.env.REACT_APP_IS_WEB === 'true' ? 'var(--ion-color-primary) !important' : undefined
          }}
        >
          {timeValue}
        </IonText>
        <IonText 
          style={{ 
            fontSize: 14,
            color: process.env.REACT_APP_IS_WEB === 'true' ? 'var(--ion-color-primary) !important' : undefined
          }}
        >
          {(valueToMs(max) / 1000).toFixed(2).replace('.', ':')}
        </IonText>
      </div>
    </div>
  );
};

export default SequencePlayer;
